// IntegrationType enum değerleri backend'deki Bw.Api/Data/Enum/IntegrationType.cs ile
// birebir eşleşir: 0 = Getir, 1 = TrendyolYemek, 2 = Yemeksepeti
export const IntegrationType = {
  Getir: 0,
  TrendyolYemek: 1,
  Yemeksepeti: 2,
};

// Her entegrasyon tipi için ayar formunda/ürün tablosunda hangi alanların/aksiyonların
// gösterileceğini tanımlayan merkezi config. IntegrationDetail.vue template'i bu config'i
// okur - yeni bir platform eklendiğinde veya bir platformun alan seti değiştiğinde sadece
// burası güncellenir, component template'ine yeni bir integrationType dalı eklemek gerekmez.
const integrationFieldConfig = {
  [IntegrationType.Getir]: {
    fields: ["isActive", "externalRestaurantSecretKey", "instantAccept", "restaurantStatus"],
    labels: {
      externalRestaurantSecretKey: "API Key",
    },
    showExcelActions: false,
    showProductStatusColumn: true,
    showProductInfoAction: true,
  },
  [IntegrationType.TrendyolYemek]: {
    // Backend'de ApiKey/SecretKey (Basic Auth), restoran durumu ve ürün durumu değişikliği
    // zaten çalışıyor ama panelde şimdiye kadar hiç gösterilmiyordu - eklendi.
    fields: ["isActive", "apiKey", "externalRestaurantSecretKey", "instantAccept", "restaurantStatus"],
    labels: {
      apiKey: "Kullanıcı Adı (ApiKey)",
      externalRestaurantSecretKey: "Şifre (SecretKey)",
    },
    showExcelActions: false,
    showProductStatusColumn: true,
    showProductInfoAction: true,
  },
  [IntegrationType.Yemeksepeti]: {
    fields: ["isActive", "externalRestaurantSecretKey", "chainId", "externalRestaurantId", "instantAccept"],
    labels: {
      externalRestaurantSecretKey: "Dış Id",
    },
    showExcelActions: true,
    showProductStatusColumn: false,
    showProductInfoAction: false,
    usesRawMaterialMapping: true,
  },
};

const emptyConfig = {
  fields: [],
  labels: {},
  showExcelActions: false,
  showProductStatusColumn: false,
  showProductInfoAction: false,
  usesRawMaterialMapping: false,
};

export function getIntegrationFieldConfig(integrationType) {
  return integrationFieldConfig[integrationType] || emptyConfig;
}

export default integrationFieldConfig;
